import { render, staticRenderFns } from "./Prototype.vue?vue&type=template&id=8528bc50&scoped=true"
import script from "./Prototype.vue?vue&type=script&lang=js"
export * from "./Prototype.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=8528bc50&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528bc50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8528bc50')) {
      api.createRecord('8528bc50', component.options)
    } else {
      api.reload('8528bc50', component.options)
    }
    module.hot.accept("./Prototype.vue?vue&type=template&id=8528bc50&scoped=true", function () {
      api.rerender('8528bc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/Textarea/Prototype.vue"
export default component.exports